const topbars = document.querySelectorAll('.abdelmeged-mobile-topbar');

if (topbars.length > 0) {
  let ticking = false;

  const update = () => {
    const isStuck = window.scrollY > 10;

    topbars.forEach((topbar) => {
      topbar.classList.toggle('is-stuck', isStuck);
    });

    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) {
      return;
    }

    ticking = true;
    window.requestAnimationFrame(update);
  };

  update();
  window.addEventListener('scroll', requestUpdate, { passive: true });
}

document.querySelectorAll('[data-mobile-search-toggle]').forEach((toggle) => {
  const panelId = toggle.getAttribute('aria-controls');
  const panel = panelId ? document.getElementById(panelId) : null;
  const input = panel?.querySelector('[data-mobile-search-input]');

  if (!panel) {
    toggle.hidden = true;
    return;
  }

  const setOpen = (isOpen, focusInput = false) => {
    toggle.setAttribute('aria-expanded', String(isOpen));
    toggle.classList.toggle('is-active', isOpen);
    panel.hidden = !isOpen;

    if (isOpen && focusInput) {
      window.requestAnimationFrame(() => input?.focus());
    }
  };

  const closeOnScroll = () => {
    if (toggle.getAttribute('aria-expanded') === 'true') {
      setOpen(false);
    }
  };

  toggle.addEventListener('click', () => {
    const isOpen = toggle.getAttribute('aria-expanded') !== 'true';
    setOpen(isOpen, isOpen);
  });

  window.addEventListener('scroll', closeOnScroll, { passive: true });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setOpen(false);
    }
  });
});
